import type { PostingGateReason } from "@/hooks/usePostingGate";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContinue: () => void;
  reason: PostingGateReason;
}

/**
 * Verification prompt removed per product decision. Component is a no-op
 * to preserve existing imports across call sites.
 */
export function VerificationWarningModal(_props: Props) {
  return null;
}
